export const isNumeric = (str: string): boolean => {
  return !Number.isNaN(str) && !Number.isNaN(parseFloat(str))
}

export const abbrNum = (number: number, decPlaces: number = 0): string => {
  let numString = number.toString();
  decPlaces = Math.pow(10, decPlaces);
  const abbrev = ['k', 'm', 'b', 't'];
  for (let i = abbrev.length - 1; i >= 0; i--) {
    const size = Math.pow(10, (i + 1) * 3);
    // If the number is bigger or equal do the abbreviation
    if (size <= number) {
      number = Math.round(number * decPlaces / size) / decPlaces;
      if ((number === 1000) && (i < abbrev.length - 1)) {
        number = 1;
        i++;
      }
      numString = number.toString();
      numString += abbrev[i];
      break;
    }
  }

  return numString;
}
